import { RTableContent } from "types/engineOutput.types"

/**
 * Type guard for engine RTable payloads. Was defined inline 8× across the
 * element hooks; the single shared copy lives here.
 */
export const isRTableContent = (
  content: unknown
): content is RTableContent => {
  return (
    typeof content === "object" &&
    content !== null &&
    "data" in content &&
    Array.isArray((content as RTableContent).data)
  )
}

/**
 * Toggles `value` in a selection list, never letting the list go empty
 * (deselecting the last remaining item is a no-op). The shared core of the
 * dashboard key/category/series/wave toggle handlers.
 */
export const toggleSelection = (current: string[], value: string): string[] => {
  const next = [...current]
  const index = next.indexOf(value)
  if (index > -1) {
    if (next.length > 1) next.splice(index, 1)
  } else {
    next.push(value)
  }
  return next
}
